import { useEffect, useRef, useState } from "react";
import { Search, X } from "lucide-react";
import { api } from "@/lib/api";
import { formatTRY } from "@/lib/format";

// Sunucu taraflı cari seçici: ünvan / kod / telefon / eski tedarikçi kodu (en fazla 20 sonuç, liste sınırı yok)
export function CariPicker({ value, label, onChange, testid = "cari-picker", placeholder = "Cari ara: ünvan, kod, telefon…", disabled, allowClear = true }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [opts, setOpts] = useState([]);
  const [busy, setBusy] = useState(false);
  const box = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => {
      setBusy(true);
      api.get("/meta/cari-picker", { params: { q } }).then(({ data }) => setOpts(data.items)).catch(() => setOpts([])).finally(() => setBusy(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q, open]);
  useEffect(() => {
    const h = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  if (value && !open) {
    return (
      <div className="h-9 border rounded px-2 flex items-center gap-2 text-[13px] bg-white" data-testid={`${testid}-selected`}>
        <span className="truncate flex-1">{label || value}</span>
        {!disabled && <button type="button" onClick={() => { if (allowClear) onChange(null); setOpen(true); }} className="text-slate-400 hover:text-slate-700" data-testid={`${testid}-clear`}><X className="h-3.5 w-3.5" /></button>}
      </div>
    );
  }
  return (
    <div className="relative" ref={box}>
      <div className="h-9 border rounded px-2 flex items-center gap-2 bg-white focus-within:ring-2 focus-within:ring-blue-200">
        <Search className="h-3.5 w-3.5 text-slate-400" />
        <input className="flex-1 text-[13px] outline-none bg-transparent" placeholder={placeholder} value={q} disabled={disabled} onFocus={() => setOpen(true)}
          onChange={(e) => { setQ(e.target.value); setOpen(true); }} data-testid={`${testid}-search`} />
      </div>
      {open && (
        <div className="absolute z-50 mt-1 w-full max-h-64 overflow-y-auto bg-white border rounded shadow-lg" data-testid={`${testid}-results`}>
          {busy && !opts.length && <div className="p-2 text-[12px] text-slate-400">Aranıyor…</div>}
          {!busy && !opts.length && <div className="p-2 text-[12px] text-slate-400">Sonuç yok</div>}
          {opts.map((o) => (
            <button type="button" key={o.id} className="w-full text-left px-2 py-1.5 hover:bg-blue-50 text-[13px] flex gap-2 items-baseline" data-testid={`${testid}-option-${o.code}`}
              onClick={() => { onChange({ ...o, label: `${o.code} · ${o.title}` }); setOpen(false); setQ(""); }}>
              <span className="font-mono text-[11px] text-slate-500">{o.code}</span>
              <span className="truncate flex-1">{o.title}{o.eski_tedarikci_kodu ? ` (${o.eski_tedarikci_kodu})` : ""}</span>
              <span className={`font-mono text-[11px] ${o.balance < 0 ? "text-rose-600" : "text-slate-500"}`}>{formatTRY(Math.abs(o.balance))} {o.balance < 0 ? "A" : o.balance > 0 ? "B" : ""}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
